import React from 'react';
import Icon from '../../../components/AppIcon';

const KPICard = ({ 
  title, 
  value, 
  change, 
  changeType, 
  icon, 
  trend = [], 
  onClick,
  className = '' 
}) => {
  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return 'TrendingUp';
    if (changeType === 'negative') return 'TrendingDown';
    return 'Minus';
  };

  return (
    <div 
      className={`bg-card border border-border rounded-lg p-6 ${className}`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
            <Icon name={icon} size={20} className="text-primary" />
          </div>
          <h3 className="text-sm font-medium text-muted-foreground">{title}</h3>
        </div>
        {/* <Icon name="MoreHorizontal" size={16} className="text-muted-foreground" /> */}
      </div>
      <div className="space-y-2">
        <div className="text-2xl font-semibold text-foreground">{value}</div>
        
        <div className="flex items-center justify-between">
          {/* <div className={`flex items-center space-x-1 text-sm ${getChangeColor()}`}>
            <Icon name={getChangeIcon()} size={14} />
            <span>{change}</span>
          </div> */}
          
          {trend?.length > 0 && (
            <div className="flex items-center space-x-1">
              {trend?.map((point, index) => (
                <div
                  key={index}
                  className={`w-1 h-4 rounded-full ${
                    point > 0 ? 'bg-success' : point < 0 ? 'bg-error' : 'bg-muted'
                  }`}
                  style={{ height: `${Math.abs(point) * 16 + 4}px` }}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default KPICard;